import React from "react";
import "./DomainCategories.css";

const domainList = [
  { name: ".com", price: "₹78" },
  { name: ".in", price: "₹49" },
  { name: ".org", price: "₹89" },
  { name: ".net", price: "₹79" },
  { name: ".shop", price: "₹59" },
  { name: ".tech", price: "₹69" },
  { name: ".info", price: "₹10" },
  { name: ".site", price: "₹39" },
];

const DomainCategories = () => {
  return (
    <section className="domain-categories">
      <div className="domain-categories-container">
        <div className="section-heading">
          <h2>Explore popular domain endings</h2>
          <p>
            Choose from the most searched and business-friendly extensions for
            your project.
          </p>
        </div>

        <div className="domain-slider-wrap">
          <div className="domain-grid-slider">
            {domainList.map((item) => (
              <div className="domain-card" key={item.name}>
                <div>
                  <span className="domain-label">Popular</span>
                  <h3>{item.name}</h3>
                </div>

                <div className="domain-card-bottom">
                  <div>
                    <h4>{item.price}</h4>
                    <p>for first year</p>
                  </div>

                  <button type="button" className="domain-add-btn">
                    Add
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DomainCategories;